
import React from "react";
import { Button } from "@/components/ui/button";
import { Users, RefreshCw, UserPlus } from "lucide-react";

interface UserProfilesEmptyStateProps {
  onRefresh: () => void;
}

const UserProfilesEmptyState: React.FC<UserProfilesEmptyStateProps> = ({ onRefresh }) => {
  return (
    <div className="text-center py-12">
      <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-500/10 to-purple-500/10 rounded-full flex items-center justify-center mb-6">
        <Users className="h-8 w-8 text-blue-500" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">No Users Found</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto leading-relaxed">
        Looks like you're one of the first here! Check back soon as more amazing teens join our community.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button 
          onClick={onRefresh}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Check Again
        </Button>
        <Button 
          onClick={() => window.location.href = '/clubs'}
          className="flex items-center gap-2 bg-primary hover:bg-primary/90"
        >
          <UserPlus className="h-4 w-4" />
          Join Communities
        </Button>
      </div>
    </div>
  );
};

export default UserProfilesEmptyState;
